import {getInitialData, ScwError, showErrorPage} from '../main';

interface ErrorState {
    error: string;
    errConfig?: any;
    meta?: any;
    validationMap?: any;
}

const {error, ...data} = getInitialData<ErrorState>();
showErrorPage(new ScwError(error, null, data));